import React, { Component } from 'react';

import {HomeController} from './home.controller';

import TaskComponent from './../task/task.component';

import { Task } from './../../classes/task.class';

let homeController;

class HomeComponent extends Component {
    constructor(props) {
        super(props);
        homeController = new HomeController({apiUrl: 'api', user: this.props.user});
        this.state = {
            tasks: homeController.getTasks(),
            selectedTask: null,
            showTagModal: false,
            filterBookmarked: this.props.filterBookmarked
        }
    }

    componentWillMount() {
        homeController.on('updateTasks', () => {
            console.log(homeController.getTasks());
            this.setState({tasks: homeController.getTasks()});
        });
    }

    _toggleTagModal(taskId = null) {
        this.setState({selectedTask: taskId, showTagModal: !this.state.showTagModal});
    }

    _handleTagSelect(tagId) {
        console.log("TAG", tagId, " Task", this.state.selectedTask);
    }

    render() {
        let tasksContent = [];
        let systemTags = [];
        let userTags = [];
        let tasks = this.state.tasks;

        if(this.props.filterBookmarked) {
            console.log("FILER");
            tasks = tasks.filter(task => {
                if(task.tags.filter(tag => tag.id === 3).length > 0) { 
                    return task;
                }
            });
        }

        systemTags = this.props.tags.filter(tag => tag.code !== null);
        userTags = this.props.tags.filter(tag => tag.code === null);

        systemTags = systemTags.map(tag => {
            return <li><button onClick={this._handleTagSelect.bind(this, tag.id)}>{tag.name}</button></li>;
        });

        userTags = userTags.map(tag => {
            return <li>{tag.name}</li>;
        });

        if(tasks.length > 0) {
            for(let i = 0; i < tasks.length; i++) {
                
                tasksContent.push(<TaskComponent key={tasks[i].id} task={tasks[i]} tags={this.props.tags} deleteTask={homeController.deleteTask.bind(homeController)} updateTask={homeController.updateTask.bind(homeController)} toggleTagModal={this._toggleTagModal.bind(this)}/>);
            }
        }else {
            tasksContent.push(<li key={null}>Loading...</li>);
        }
        

        return (
            
            <div>
                <ul className="home-tasks">
                    {tasksContent}
                </ul>
                <button className="app-btn  app-btn--create" onClick={homeController.saveTask.bind(homeController)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" class="feather feather-plus"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                </button>

                <section className="tag-modal" style={{display: this.state.showTagModal ? 'inherit' : 'none'}}>
                    <ul>
                        <h3>System-Tag's</h3>
                        {systemTags}
                    </ul>
                    <ul>
                        <h3>User-Tag's</h3>
                        {userTags}
                    </ul>
                </section>
            </div>
        );
    }
}

export default HomeComponent;


// WEBPACK FOOTER //
// src/components/home/home.component.js